iScreenWizard.factory('Ajax', function ($rootScope, Base64, $http, $q, crypStorage, userService) {

	var apiUrl = baseUrl+'/wizard/',
	    data = {},
		parsedurl;

	var setHeaders = function() {
		$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
	};


	var getToken = function() {
		return crypStorage.get(tkey)
	};

	var getTokenizedUrl = function(url){
		return apiUrl.concat(url).concat('?jwt=' + getToken());
	};


	var param = function(obj) {
		var query = '', name, value, fullSubName, subName, subValue, innerObj, i;

		for(name in obj) {
			value = obj[name];

			if(value instanceof Array) {
				for(i=0; i<value.length; ++i) {
					subValue = value[i];
					fullSubName = name + '[' + i + ']';
					innerObj = {};
					innerObj[fullSubName] = subValue;
					query += param(innerObj) + '&';
				}
			}
			else if(value instanceof Object) {
				for(subName in value) {
					subValue = value[subName];
					fullSubName = name + '[' + subName + ']';
					innerObj = {};
					innerObj[fullSubName] = subValue;
					query += param(innerObj) + '&';
				}
			}
			else if(value !== undefined && value !== null)
				query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
		}

		return query.length ? query.substr(0, query.length - 1) : query;
	};

	// Override $http service's default transformRequest
	$http.defaults.transformRequest = [function(data) {
		return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
	}];

	data.setHeaders = setHeaders;
	data.getTokenizedUrl = getTokenizedUrl;

	data.get = function (url, params) {
		return $q(function (resolve, reject) {
			setHeaders();
			parsedurl = getTokenizedUrl(url);
			angular.forEach(params, function(value, attribute) {
				parsedurl = parsedurl + "&" + attribute + "=" + value;
			});
           if (locale_id > 0) {
               parsedurl = parsedurl + '&_content_language=' + locale_id;
		   }

            $http.get(parsedurl).then(resolve, function (response) {
				if (response.status === 401) {
					data.handle401(response).then(function(){
						data.get(url, params).then(resolve, reject);
					},reject)
				} else {
					reject(response);
				}
			});
		});
	};

	data.post = function (url, params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        if (locale_id > 0) {
            params._content_language = locale_id;
        }
		return $q(function (resolve, reject) {
			setHeaders();
			$http.post(getTokenizedUrl(url), params).then(resolve, function (response) {
				if (response.status === 401) {
					data.handle401(response).then(function(){
						data.post(url, params).then(resolve, reject);
					},reject)
				} else {
					reject(response);
				}
			});
		});
	};

	data.put = function (url, params) {
		params['_method'] = 'put';
        if (locale_id > 0) {
            params._content_language = locale_id;
        }
		return $q(function (resolve, reject) {
			setHeaders();
			$http.post(getTokenizedUrl(url), params).then(resolve, function (response) {
				if (response.status === 401) {
					data.handle401(response).then(function(){
						data.put(url, params).then(resolve, reject);
					},reject)
				} else {
					reject(response);
				}
			});
		});
	};

	data.delete = function (url) {
		params = {
			_method: 'delete'
		};
        if (locale_id > 0) {
            params._content_language = locale_id;
        }
		return $q(function (resolve, reject) {
			setHeaders();
			$http.post(getTokenizedUrl(url), params).then(resolve, function (response) {
				if (response.status === 401) {
					data.handle401(response).then(function(){
						data.delete(url).then(resolve, reject);
					},reject)
				} else {
					reject(response);
				}
			});
		});
	};

	data.handle401 = function (response) {
		return $q(function (resolve, reject) {
			userService.logout();
			reject(response);
		});
	};

	data.timeToRegenerateToken = function() {
		if (userService.isAuthenticated()) {
			return (userService.model.loginExpires - Math.floor(Date.now() / 1000)) < REGENERATE_TOKEN_SECONDS_BEFORE_INVALIDATION;
		}
		return false;
	};

	data.regenerateToken = function() {
		params = {
			_method: 'regenerate'
		};
		data.post('authenticate', params).then(function (response) {
			if (response.data.succes > 0) {
				userService.token = response.data.jwt;
				userService.model.loginExpires = response.data.jwt_expires_at;
				userService.SaveState();
			} else {
				userService.logout();
			}
		});
	};

	$rootScope.$on('$stateChangeSuccess', function (event, toState) {
		if (data.timeToRegenerateToken()) {
			data.regenerateToken();
		}
	});

	return data;
});